import { render, staticRenderFns } from "./UpTextinput.vue?vue&type=template&id=5135356b&scoped=true"
import script from "./UpTextinput.vue?vue&type=script&lang=js"
export * from "./UpTextinput.vue?vue&type=script&lang=js"
import style0 from "./UpTextinput.vue?vue&type=style&index=0&id=5135356b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5135356b",
  null
  
)

export default component.exports